import React, { useState, useEffect, useRef } from 'react';
import { Pressable, Text, View } from 'react-native';
// Immerse related imports removed for web compatibility
import { useIsFocused } from '@react-navigation/native';
import { MainNavProps } from './navigation/main/MainParamList';
import { black, white } from '../assets/style/colors';
import { showToast } from '../components/Toast';
import {
  Str_FatchUserFailure,
  Str_GroupDisbanded,
  Str_MyQRCode,
  Str_QRCodeInvalid,
  Str_ScannerQRCodeErr,
} from '../language/string_res';
import { ImageView } from '../components/ImageView';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStore } from '../store/UserStore';
import * as ImSdk from '../../imsdk/api';
import { TopicWithSummary } from '../../imsdk/api/topic';
import { useNavigationToChatView2 } from './Chat/chat-helper';
import { isGroupTopic } from '../utils/utils';
import { showDialog, showMsgDialog } from '../components/CommonDialog';
import { postJson } from '../net/http';
import { isUrlText } from '../utils/CommonUtils';
type PCProps = {
  mac: string;
  ip: string;
  timestamp: string;
};
const BarCodeScanner = ({ navigation }: MainNavProps<'BarCodeScanner'>) => {
  const isFocused = useIsFocused();
  const insets = useSafeAreaInsets();
  const { state } = useStore();
  const [user, setUser] = useState(state?.user);
  const im = ImSdk.getInstance();
  const toChatView = useNavigationToChatView2();
  const isShowingAlert = useRef(false)

  useEffect(() => {
    if (state?.user) {
      setUser(state?.user);
    }
  }, [state?.user]);
  useEffect(() => {
    im.GetUserRemote(im.CurrentUid()).then((res) => {
      if (res && res.users && res.users.length > 0) {
        const user = res.users[0];
        setUser(user);
      }
    });
  }, []);

  // Immerse related code removed for web compatibility
  useEffect(() => {
    if (isFocused) {
      isShowingAlert.current = false;
    }
    return () => {
      isShowingAlert.current = false;
    };
  }, [isFocused]);

  function parseQueryString(queryString: string) {
    const queries = queryString.split('&');
    const data = { code: '', tid: '', uid: 0 };
    for (let i = 0; i < queries.length; i++) {
      const param = queries[i];
      const index = param.indexOf('=');
      if (index > 1) {
        const key = param.substring(0, index);
        if (index + 1 < param.length) {
          const value = param.substring(index + 1, param.length);
          if ('code' === key) {
            data.code = value;
          }
          if ('tid' === key) {
            data.tid = value;
          }
          if ('uid' === key) {
            data.uid = Number(value);
          }
        }
      }
    }
    return data;
  }

  function parseUrlParams(url: string) {
    const index = url.indexOf('?');
    if (index === -1) {
      return { code: '', tid: '', uid: 0 };
    }
    const query = url.slice(index + 1); // 移除查询字符串开头的'?'
    return parseQueryString(query);
  }

  async function handleApplyAdd(value: string) {
    const params = parseUrlParams(value);
    const code = params.code;
    const tid = params.tid;
    const uid = params.uid;
    if (code.length === 0) {
      const data: PCProps = JSON.parse(value);

      if (data && data.mac && data.ip && data.timestamp) {
        postJson('/v1/pc/scan', {
          body: data,
          useToken: true,
          debug: __DEV__,
        }).then((res: any) => {
          if (res.data && res.data.id) {
            navigation.replace('PcLoginConfirmScreen', {
              id: res.data.id.toString(),
            });
          } else {
            showMsgDialog(res?.msg || Str_QRCodeInvalid);
          }
        });
      } else if (isUrlText(value)) {
        navigation.replace('CommonWeb', { url: value, showBack: true });
      } else {
        showDialog({
          message: Str_ScannerQRCodeErr,
          onConfirm: () => {
            isShowingAlert.current = false;
          },
        });
      }
      return;
    }
    if (tid.length > 0) {
      const isGroup = isGroupTopic(tid)
      const r = await im.GetTopicDetail(tid);
      let inTopic = false
      if (isGroup) {
        const resp = await im.GetGroupRemote(tid);
        if (r.topic) {
          r.topic.group = resp.group
          r.topic.users = resp.members
          const index = resp.members?.findIndex(v => v.uid === im.CurrentUid()) || -1
          inTopic = index >= 0
        }
      } else {
        const resp = await im.GetContact({ uid: uid })
        if (resp.refs && resp.refs.length > 0) {
          inTopic = resp.refs[0].isfriend === 1
        }
      }
      if (isGroup && r.topic?.group?.flag === 2) {
        showToast(Str_GroupDisbanded)
        isShowingAlert.current = false;
        return
      }
      if (r.topic && inTopic) {
        handleNavigation(r.topic);
        isShowingAlert.current = false;
        return;
      }
      navigation.replace('ScannerApplyScreen', {
        type: tid.length > 0 ? 'Group' : 'User',
        tid: tid,
        touid: uid,
        code: code,
      });
    } else {
      im.GetUserRemote(uid).then((r) => {
        if (r.users && r.users[0]) {
          navigation.replace('ContactInfo', { current: r.users[0] });
        } else {
          showToast(Str_FatchUserFailure);
          isShowingAlert.current = false;
        }
      });
    }
  }

  function handleNavigation(item: TopicWithSummary) {
    toChatView(item, true);
  }

  const NavQRCodeScreen = () => {
    navigation.navigate('QRCodeScreen', { user: user });
  };

  return (
    <View style={{ flex: 1, backgroundColor: black, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Text style={{ color: white, fontSize: 16 }}>扫码功能在 Web 版本中不可用</Text>
      <ImageView
        style={{
          position: 'absolute',
          start: 20,
          top: insets.top + 20,
          backgroundColor: white,
          borderRadius: 20,
          justifyContent: 'center',
          alignItems: 'center',
          width: 30,
          height: 30,
        }}
        activeOpacity={1}
        onClick={() => navigation.goBack()}
        imgStyle={{ width: 14, height: 14, objectFit: 'contain' }}
        source={require('../assets/image/icon_back.png')}
      />
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginHorizontal: 24,
          marginBottom: insets.bottom + 30,
        }}
      >
        <Pressable
          onPress={NavQRCodeScreen}
          style={{ justifyContent: 'center', alignItems: 'center' }}
        >
          <ImageView
            style={{
              borderRadius: 40,
              width: 44,
              height: 44,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
            activeOpacity={1}
            onClick={NavQRCodeScreen}
            imgStyle={{ width: 24, height: 24, objectFit: 'contain' }}
            source={require('../assets/image/icon_mine_qr.png')}
          />
          <Text style={{ color: white, fontSize: 12 }}>{Str_MyQRCode}</Text>
        </Pressable>
      </View>
    </View>
  );
};

export default BarCodeScanner;
